import { render, staticRenderFns } from "./ModelAdjustments.vue?vue&type=template&id=273bdf3e&scoped=true"
import script from "./ModelAdjustments.vue?vue&type=script&lang=js"
export * from "./ModelAdjustments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273bdf3e",
  null
  
)

export default component.exports